<template>
  <div class="wrapper">
    <FORM ref="childForm" @formclick="formClick" :formData="formData"></FORM>
    <table-page ref="childTable"  :pageData="pageData"></table-page>
  </div>
</template>

<script>
import tablePage from '@/components/page/table.vue'
import FORM from '@/components/page/form.vue'
import DateUtil from '@/utils/IM/tradeDataUtil.js'
import Qs from 'qs'
import Url from '@/views/crs/util/url'
import UPDATE from '@/components/page/update'

export default {
  name: 'list',
  components: {
    tablePage,
    FORM
  },
  created() {

  },
  methods: {

    /*查询表单按钮点击事件*/
    formClick(clickName, data) {
      if (window.$t('common.search') == clickName || '查询' == clickName) {
        this.queryData = data
        this.$refs.childTable.defaultGetData(data)
      }
    },
  },
  data() {
    return {
      queryData: {},
      /*from查询表单*/
      formData: {
        hasLable: true,
        cols: [
          {
            title: 'businessTypeAlias',
            field: 'businessTypeAlias',
            data: DateUtil.getParamKey(this.$route.params),
            hidden: true
          },
          { title: '賬號', field: 'customerNumber', isNumber: true },
          { title: '活動ID', field: 'actId', isNumber: true },
          { click: window.$t('common.search') }
        ]
      },
      /*table生成*/
      pageData: {
        isShow: false,
        queryUrl: Url.quantityTask.activity.dicesDetail,
        selection: false,
        sequence: true,
        method: 'get',
        cols: [
          {
            title: '時間', field: 'ctime', render: (data, full) => {
              return DateUtil.formatDate(data, 'yyyy-MM-dd hh:mm:ss')
            }
          },
          { title: '賬號', field: 'customerNumber' },
          { title: '活動ID', field: 'actId' },
          { title: '塞子數', field: 'quantity' },
          { title: '關卡', field: 'level' },
        ]
      }
    }
  }
}
</script>
